// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-message {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 300px;
  border-radius: 8px;
  overflow: hidden;
}

.location-message-map-container {
  position: relative;
  width: 100%;
  height: 200px;
  background: #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
}

.location-message-map {
  width: 100%;
  height: 100%;
  border: none;
}

/* MapLibre control positioning */
.location-message-map .maplibregl-ctrl-attrib {
  font-size: 10px;
  background: rgba(255, 255, 255, 0.8);
}

/* Ensure MapLibre controls are visible */
.location-message-map .maplibregl-ctrl-group {
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
}

/* Fix canvas rendering */
.location-message-map canvas {
  outline: none;
}

.location-message-map-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #666;
  background: #f5f5f5;
}

.location-message-map-fallback ion-icon {
  font-size: 32px;
}

.location-message-details {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  position: relative;
}

.location-message-open-btn {
  flex-shrink: 0;
  background: transparent;
  border: none;
  color: #4A90E2;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.location-message-open-btn:hover {
  background: rgba(74, 144, 226, 0.1);
}

.location-message-open-btn:active {
  background: rgba(74, 144, 226, 0.2);
}

.location-message-open-btn ion-icon {
  font-size: 18px;
}

.location-message-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4A90E2;
}

.location-message-icon ion-icon {
  font-size: 20px;
}

.location-message-text {
  flex: 1;
  min-width: 0;
}

.location-message-label {
  font-weight: 500;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.location-message-coords {
  font-size: 12px;
  color: #666;
  font-family: monospace;
}

/* Error state */
.location-message--error {
  flex-direction: row;
  padding: 12px;
  background: #fff3cd;
  border: 1px solid #ffc107;
}

.location-message--error .location-message-icon {
  color: #ff9800;
}

.location-message--error .location-message-coords {
  color: #d32f2f;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/LocationMessage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA,yCAAyC;AACzC;EACE,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".location-message {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 300px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.location-message-map-container {\n  position: relative;\n  width: 100%;\n  height: 200px;\n  background: #f0f0f0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.location-message-map {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n/* MapLibre control positioning */\n.location-message-map .maplibregl-ctrl-attrib {\n  font-size: 10px;\n  background: rgba(255, 255, 255, 0.8);\n}\n\n/* Ensure MapLibre controls are visible */\n.location-message-map .maplibregl-ctrl-group {\n  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);\n}\n\n/* Fix canvas rendering */\n.location-message-map canvas {\n  outline: none;\n}\n\n.location-message-map-fallback {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #666;\n  background: #f5f5f5;\n}\n\n.location-message-map-fallback ion-icon {\n  font-size: 32px;\n}\n\n.location-message-details {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 4px;\n  position: relative;\n}\n\n.location-message-open-btn {\n  flex-shrink: 0;\n  background: transparent;\n  border: none;\n  color: #4A90E2;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.location-message-open-btn:hover {\n  background: rgba(74, 144, 226, 0.1);\n}\n\n.location-message-open-btn:active {\n  background: rgba(74, 144, 226, 0.2);\n}\n\n.location-message-open-btn ion-icon {\n  font-size: 18px;\n}\n\n.location-message-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #4A90E2;\n}\n\n.location-message-icon ion-icon {\n  font-size: 20px;\n}\n\n.location-message-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.location-message-label {\n  font-weight: 500;\n  font-size: 14px;\n  color: #333;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.location-message-coords {\n  font-size: 12px;\n  color: #666;\n  font-family: monospace;\n}\n\n/* Error state */\n.location-message--error {\n  flex-direction: row;\n  padding: 12px;\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n}\n\n.location-message--error .location-message-icon {\n  color: #ff9800;\n}\n\n.location-message--error .location-message-coords {\n  color: #d32f2f;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
